// extracted by mini-css-extract-plugin
module.exports = {"ExternalOrderPaymentModal":"ExternalOrderPaymentModal_ExternalOrderPaymentModal__2wVgU","DoNotShowAgainLabel":"ExternalOrderPaymentModal_DoNotShowAgainLabel__1-fME"};